var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0564 0.812249C10.1303 0.812117 10.2036 0.826555 10.2719 0.854739C10.3402 0.882922 10.4023 0.924297 10.4547 0.976499L16.0234 6.54525C16.1289 6.65073 16.1881 6.79378 16.1881 6.94294C16.1881 7.09209 16.1289 7.23514 16.0234 7.34062C15.4834 7.88062 14.8174 8.00212 14.3325 8.00212C14.1334 8.00212 13.9557 7.98187 13.815 7.95825L10.2893 11.484C10.3821 11.858 10.4423 12.2393 10.4693 12.6236C10.521 13.4134 10.4333 14.5215 9.65929 15.2955C9.55381 15.401 9.41076 15.4602 9.2616 15.4602C9.11245 15.4602 8.9694 15.401 8.86391 15.2955L5.68129 12.114L2.10154 15.6937C1.88216 15.9131 0.730163 16.7085 0.510788 16.4891C0.291413 16.2697 1.08679 15.1166 1.30616 14.8984L4.88591 11.3186L1.70441 8.136C1.59896 8.03051 1.53972 7.88747 1.53972 7.73831C1.53972 7.58916 1.59896 7.44611 1.70441 7.34062C2.47841 6.56662 3.58654 6.47775 4.37629 6.53062C4.76065 6.55756 5.14196 6.61778 5.51591 6.71062L9.04166 3.186C9.01223 3.01468 8.99718 2.8412 8.99666 2.66737C8.99666 2.18362 9.11816 1.51762 9.65929 0.976499C9.76471 0.871347 9.90752 0.812281 10.0564 0.812249Z",
    fill: "#383838"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPin);
export default __webpack_public_path__ + "static/media/pin.acfabafeaddf753f1e4b4f786a035f50.svg";
export { ForwardRef as ReactComponent };